import styled from 'styled-components';
import MediaSizes from '@widgets/shared/MediaSizes';
export const Wrapper = styled.div `
  @media screen and (max-width: ${MediaSizes.MD_MAX}px) {
    margin-top: 4rem;
  }
`;
export const Icon = styled.picture `
  display: block;
  line-height: 0;
  
  &, img {
    max-width: 100%;
  }
`;
export const List = styled.ul `
  list-style: none;
  display: flex;
  justify-content: center;
  gap: 0.8rem;
  padding: 0;
`;
export const ListItem = styled.li `
  width: 7.8rem;
  height: 4.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0.1rem solid var(--border);
  border-radius: var(--border-radius-sm);
  padding: 0.8rem 1.5rem;
`;
export default {
    Wrapper,
    ListItem,
    List,
    Icon,
};
